import { BaseComponent } from "../../../../../../../react-core/Html/BaseComponent";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../Store/Variable";
import {
    getSelectedAccountsInceptionDate,
    getSelectedHeadAccount,
    getSelectedHeadClAccountId,
    getSelectedSubAccountIds,
} from "./PortfolioDashboardHelper";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import {ignoreOrderCompare} from "../../../../../../Shared/Utils/ArrayUtils";

export interface IPortfolioDashboardComponentProps {
    customerid: number;
    hasReadWriteAccessToAdviser?: boolean;
    isBtnPresentationClicked: boolean[];
    onPresentationViewStatusChange: (tabIndex: portfolioDashboardTabEnum, isPresentationClickedPre: boolean[]) => void;
}

export abstract class PortfolioDashboardComponent<
    TProps extends IPortfolioDashboardComponentProps,
    TState
> extends BaseComponent<TProps, TState> {
    private _existingSelection: string[] = [];

    constructor(props: any) {
        super(props);
        this.initState();
        this.subscribeToStore(PortfolioDashboardMultiSelectionStore, () => this.onMultiSeletionChange());
    }

    componentDidMount() {
        const selection = PortfolioDashboardMultiSelectionStore.getData();

        this._existingSelection = selection;
        this.getData(selection);
    }

    protected onMultiSeletionChange() {
        const selection = PortfolioDashboardMultiSelectionStore.getData();

        if (!ignoreOrderCompare(selection, this._existingSelection)) {
            this.getData(selection);
        }

        this._existingSelection = selection;
    }

    protected getSelectedHeadAccountHierarchyIds(): string[] {
        const selection = PortfolioDashboardMultiSelectionStore.getData();
        const clientAccounts = PortfolioDashboardStore.getData();
        return getSelectedHeadAccount(selection, clientAccounts);
    }

    protected getSelectedHeadClAccountIds(): string[] {
        const selection = PortfolioDashboardMultiSelectionStore.getData();
        const clientAccounts = PortfolioDashboardStore.getData();
        return getSelectedHeadClAccountId(selection, clientAccounts);
    }

    protected getSelectedAccountsInceptionDate(): Date {
        const selection = PortfolioDashboardMultiSelectionStore.getData();
        const clientAccounts = PortfolioDashboardStore.getData();
        return getSelectedAccountsInceptionDate(selection, clientAccounts);
    }

    protected getSelectedSubAccountIds(): string[] {
        const selection = PortfolioDashboardMultiSelectionStore.getData();
        const clientAccounts = PortfolioDashboardStore.getData();
        return getSelectedSubAccountIds(selection, clientAccounts);
    }
    abstract initState();

    abstract getData(selectedSubAccountHierarchyIds: string[]);

    abstract render();
}
